import { Provider } from "components/ui/provider";
import { ThemeProvider } from "contexts/ThemeContext";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./i18n/config"; // Initialize i18n
import "./index.css";

import App from "./App";

if (window.top === window.self) {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <BrowserRouter>
      <ThemeProvider>
        <Provider>
          <App />
        </Provider>
      </ThemeProvider>
    </BrowserRouter>,
  );
}
